import React from 'react';
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./Player.css";

function Player({currentStation, setIsPlaying}) {
	return (
		<div className="player-card">
			<AudioPlayer
				src={currentStation.url}
				autoPlay
				showJumpControls={false}
				customProgressBarSection={['MAIN_CONTROLS']}
				customControlsSection={['VOLUME_CONTROLS']}
				customIcons={{
					play: (
						<span className="material-symbols-outlined rhap-material-icon play" aria-hidden="true">
                                play_circle
                              </span>
					),
					pause: (
						<span className="material-symbols-outlined rhap-material-icon stop" aria-hidden="true">
                                stop_circle
                              </span>
					),
					volume: (
						<span className="material-symbols-outlined rhap-material-icon" aria-hidden="true">
                                volume_up
                              </span>
					),
					volumeMute: (
						<span className="material-symbols-outlined rhap-material-icon" aria-hidden="true">
                                volume_off
                              </span>
					),
				}}
				layout="horizontal"
				className="modern-audio-player"
				customAdditionalControls={[]}
				onPlay={() => setIsPlaying(true)}
				onPause={() => setIsPlaying(false)}
				onEnded={() => setIsPlaying(false)}
			/>
		</div>
	)
}

export default Player;
